<script>
  export default {
    name: 'renderless-footer',
    data() {
      return {
        currentViewport: null
      };
    },
    mounted() {
      window.addEventListener('resize', this.resizeMethod);
      this.resizeMethod();
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.resizeMethod);
    },
    methods: {
      resizeMethod() {
        this.currentViewport = Number.parseInt(window.getComputedStyle(document.documentElement).width) || 0;
      }
    },
    render() {
      return this.$scopedSlots.default({
        mobile: this.currentViewport < 768,
        tablet: this.currentViewport >= 768 && this.currentViewport < 1024,
        desktop: this.currentViewport >= 1024 && this.currentViewport < 1440,
        desktop2x: this.currentViewport >= 1440
      });
    }
  };
</script>
